import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-259b2ab2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading",
  width: "48",
  height: "16",
  viewBox: "0 0 48 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "8",
  r: "3",
  fill: "#dfe1e6"
}, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "24",
  cy: "8",
  r: "3",
  fill: "#00479d"
}, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "36",
  cy: "8",
  r: "3",
  fill: "#dfe1e6"
}, null, -1 /* HOISTED */))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode($setup["BaseInput"], {
      ref: "baseInput",
      placeholder: $props.placeholder,
      name: $props.name,
      label: $props.label,
      errorMessage: $setup.checkDuplicateErrorMsg,
      successMessage: $setup.checkDuplicateSuccessMsg,
      disabled: $props.disabled,
      required: $props.required,
      value: $setup.inputValue,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputValue) = $event)),
      rules: $setup.getRules
    }, _createSlots({ _: 2 /* DYNAMIC */ }, [
      ($props.certRequired)
        ? {
            name: "inputInnerButton",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "extraElement", {}, undefined, true),
              ($setup.isLoading)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    ref: "button",
                    class: "btn",
                    type: "button",
                    disabled: $props.disabled || $setup.isCheckDuplicateSuccess,
                    onClick: $setup.checkDuplicateId
                  }, " 중복확인 ", 8 /* PROPS */, _hoisted_6))
            ]),
            key: "0"
          }
        : undefined
    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["placeholder", "name", "label", "errorMessage", "successMessage", "disabled", "required", "value", "rules"])
  ]))
}